import { isDefined } from "@clipboard-health/util-ts";
import { useGetShiftBoosts } from "@src/appV2/redesign/Shift/ShiftBoost/api/useGetShiftBoosts";

interface GetAvailableAndAppliedShiftBoostParams {
  workerId: string;
  shiftId?: string;
}

interface GetAvailableAndAppliedShiftBoostOptions {
  enabled: boolean;
}

export function useGetAvailableAndAppliedShiftBoosts(
  params: GetAvailableAndAppliedShiftBoostParams,
  options: GetAvailableAndAppliedShiftBoostOptions
) {
  const { workerId, shiftId } = params;

  const { data: shiftBoosts, isLoading: shiftBoostsAreLoading } = useGetShiftBoosts(
    { workerId, statuses: ["AVAILABLE", "APPLIED"] },
    { enabled: isDefined(shiftId) && options.enabled }
  );

  const availableShiftBoost = shiftBoosts?.data.find(
    (boost) => boost.attributes.status === "AVAILABLE"
  );
  const appliedShiftBoost = shiftBoosts?.data.find(
    (boost) =>
      boost.attributes.status === "APPLIED" && boost.relationships.shift?.data.id === shiftId
  );

  return {
    availableShiftBoost,
    appliedShiftBoost,
    shiftBoostsAreLoading,
  };
}
